import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import ReimbursementSummaryCommon, {getDefaultState as getReimbursementSummaryCommonDefaultState} from './reimbursement-summary-common';
import ReimbursementSummaryCity from './reimbursement-summary-city';
import t from 'tcomb';

const ReimbursementSummaryLeadAccount = ReimbursementSummaryCommon.extend({
    citySummary: t.list(ReimbursementSummaryCity, 'CitySummary'),
    leadAccount: Dealer
}, {
    name: 'ReimbursementSummaryLeadAccount',
    strict: true
});

export const getDefaultState = () => new ReimbursementSummaryLeadAccount({
    ...getReimbursementSummaryCommonDefaultState(),
    citySummary: [],
    leadAccount: getDealerDefaultState()
});

export default ReimbursementSummaryLeadAccount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account.js